const ytThumb = (id) => `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;

export const POPUP_PROJECTS = [
  {
    key: "gyan-dhara",
    title: "Gyan Dhara",
    tags: ["Immersive learning", "Government"],
    card: { type: "placeholder", file: "gd-students5.jpg" },
    cardBlurb:
      "A curriculum-aligned virtual reality learning platform for Grade 8 and 9 science and mathematics, running on standalone headsets in Assam government classrooms.",
    cardMeta: "Dept. of Science and Technology, Government of Assam · 2025 to 2027",
    meta: "Dept. of Science and Technology, Government of Assam · ₹5.90 crore, about USD 690,000 · Sole PI · 2025 to 2027",
    images: [
      { file: "gd-students5.jpg", caption: "Students in headsets during a Gyan Dhara session" },
      { file: "gd-workshop-teachers1.jpg", caption: "Teacher workshop for Gyan Dhara" },
      { file: "gd-champ-moderating.jpg", caption: "A student champion moderating a session" },
    ],
    brief:
      "A curriculum-aligned virtual reality learning platform for Grade 8 and 9 science and mathematics, running on standalone headsets in Assam government classrooms with no laboratory and no reliable network. An eight-week field study across two schools showed a learning gain that was still present six weeks later.",
    videos: [
      { title: "Platform showcase", url: "https://youtube.com/watch?v=AzQDeSmaDdA" },
      { title: "Module: Sound", url: "https://youtu.be/Ha42Bc3wK-E" },
    ],
    site: "https://www.gyan-dhara.com",
    siteLabel: "Visit gyan-dhara.com",
  },
  {
    key: "evam",
    title: "Evam",
    tags: ["Immersive learning", "Government"],
    card: { type: "placeholder", file: "evam-minister.jpg" },
    cardBlurb:
      "The educational metaverse platform that Gyan Dhara grew out of, installed in unsupervised public use at the Guwahati Planetarium.",
    cardMeta: "GPMS, Government of Assam · 2023 to 2025",
    meta: "GPMS, Government of Assam · ₹1 crore, about USD 116,000 · PI with Debayan Dhar as Co-PI · 2023 to 2025",
    images: [
      { file: "evam-minister.jpg", caption: "Evam demonstrated at its launch" },
      { file: "evam-launch.jpg", caption: "Evam launch event" },
      { file: "evam-field1.jpg", caption: "Evam in public use" },
    ],
    brief:
      "The educational metaverse platform that Gyan Dhara grew out of. A library of room-scale VR learning experiences for school science, commissioned by the Government of Assam and installed in unsupervised public use at the Guwahati Planetarium.",
    videos: [],
    site: "https://evameduvr.wixsite.com/evamvr",
    siteLabel: "Visit the Evam site",
  },
  {
    key: "disability-inclusive-virtual-shopping",
    title: "Disability-inclusive virtual shopping",
    tags: ["Accessibility", "Industry"],
    card: { type: "placeholder", file: "wm-test3.jpg" },
    cardBlurb:
      "A contextual inquiry with thirteen partially sighted Indian consumers produced eleven design guidelines for inclusive immersive retail.",
    cardMeta: "Walmart · Nov 2024 to Nov 2025",
    meta: "Walmart · ₹33,00,000, about USD 38,000 · Sole PI · Nov 2024 to Nov 2025 · Three papers under review",
    images: [
      { file: "wm-test3.jpg", caption: "A participant testing the virtual shopping prototype" },
      { file: "wm-inspect1.jpg", caption: "Product inspection during fieldwork" },
      { file: "wm-shopkeeper.jpg", caption: "Fieldwork at a shop" },
    ],
    brief:
      "Virtual reality retail is designed for people who can see it. A contextual inquiry with thirteen partially sighted Indian consumers, studied where they actually shop, produced eleven design guidelines for inclusive immersive retail.",
    videos: [],
    site: null,
  },
  {
    key: "pragati",
    title: "Pragati",
    tags: ["Health systems", "Government"],
    card: { type: "placeholder", file: "pragati-vr1.jpg" },
    cardBlurb:
      "Mobile VR training delivered on a community health worker's own phone with a low-cost viewer, to more than 600 health workers across three Assam districts.",
    cardMeta: "ICMR and Ministry of Education, IMPRINT · 2017 to 2019",
    meta: "ICMR and Ministry of Education, IMPRINT, with IBM Research Labs India as industry partner · ₹44,96,208, about USD 52,000 · Sole PI · 2017 to 2019",
    images: [
      { file: "pragati-vr1.jpg", caption: "A health worker using Pragati in a low-cost viewer" },
      { file: "pragati-training.jpg", caption: "A Pragati training session" },
    ],
    brief:
      "Mobile VR training delivered on a community health worker's own phone with a low-cost viewer, so procedural training could happen at the sub-centre rather than the district headquarters. Delivered to more than 600 health workers across three Assam districts.",
    videos: [{ title: "Project video", url: "https://youtube.com/watch?v=5qiGfPzKOpM" }],
    site: null,
  },
  {
    key: "swasthyaa",
    title: "Swasthyaa",
    tags: ["Health systems", "Completed"],
    card: { type: "placeholder", file: "swasthyaa-launch2.jpg" },
    cardBlurb:
      "Tuberculosis treatment adherence tracked inside the blister pack itself. Used by 1,100 patients over a three-month pilot.",
    cardMeta: "ICMR and Ministry of Education, IMPRINT · 2017 to 2019",
    meta: "ICMR and Ministry of Education, IMPRINT · ₹50,00,000, about USD 58,000 · PI with Professor Pratul Kalita as Co-PI · 2017 to 2019",
    images: [
      { file: "swasthyaa-launch2.jpg", caption: "Swasthyaa launch" },
      { file: "swasthyaa-training3.jpg", caption: "Swasthyaa training session" },
      { file: "swasthyaa-officers.jpg", caption: "Programme officers with the Swasthyaa system" },
    ],
    brief:
      "Tuberculosis treatment adherence tracked inside the blister pack itself, so taking the dose recorded the dose with nothing to read or write. Used by 1,100 patients; the treatment defaulter rate fell from twenty-five per cent to seventeen per cent over a three-month pilot.",
    note:
      "No results paper was published from this project. The outcome figure rests on the pilot record and the programme's own reporting rather than on peer review.",
    videos: [{ title: "Project video", url: "https://youtube.com/watch?v=gDTRqLEBYIA" }],
    site: null,
  },
  {
    key: "chetna",
    title: "Chetna",
    tags: ["Health systems", "Industry"],
    card: { type: "placeholder", file: "chetna-system.jpg" },
    cardBlurb:
      "A gesture-mediated maternal health information system for rural mothers with little or no literacy in Assam.",
    cardMeta: "IBM Research Labs, India · 2012 to 2013",
    meta: "IBM Research Labs, India · ₹8,00,000, about USD 9,300 · Sole PI · 2012 to 2013",
    images: [
      { file: "chetna-system.jpg", caption: "The Chetna system" },
      { file: "chetna-mothers1.jpg", caption: "Mothers using Chetna" },
    ],
    brief:
      "A gesture-mediated maternal health information system for rural mothers with little or no literacy in Assam. The gesture vocabulary was established empirically with the users themselves before the interface was built.",
    videos: [
      { title: "Project video 1", url: "https://youtu.be/VTBdmfJ7Gno" },
      { title: "Project video 2", url: "https://youtu.be/GGkP90sozms" },
      { title: "Project video 3", url: "https://youtu.be/mTzBmw6eG40" },
    ],
    site: null,
  },
  {
    key: "first-time-voter-training",
    title: "First-time voter training",
    tags: ["Civic technology", "Government"],
    card: { type: "placeholder", file: "voter1.jpg" },
    cardBlurb:
      "A VR application that walks a first-time voter through the entire polling sequence, piloted at one college and extended by the district administration.",
    cardMeta: "Assam state administration · Piloted April 2024",
    meta: "Assam state administration · No external funding, built in-house · Sole PI · Piloted April 2024",
    images: [
      { file: "voter1.jpg", caption: "First-time voter training in use" },
      { file: "voter2.jpg", caption: "A voter walking through the polling sequence" },
      { file: "voter3.jpg", caption: "The training pilot at a college" },
    ],
    brief:
      "A VR application that walks a first-time voter through the entire polling sequence: entering the station, presenting identification, finding the booth, reading the ballot unit and casting the vote. Piloted at one college; the district administration then extended it to further colleges on its own initiative.",
    videos: [],
    site: null,
  },
  {
    key: "accessible-mobile-apps",
    title: "Accessible mobile apps",
    tags: ["Accessibility", "Industry"],
    card: { type: "youtube", id: "8r_aw1tXco0", file: "youtube-thumb-8r_aw1tXco0.jpg" },
    cardBlurb:
      "Two accessible mobile interaction studies commissioned by Samsung's India research institute and delivered as working prototypes with user studies.",
    cardMeta: "Samsung Research Institute India · 2013 to 2015",
    meta: "Samsung Research Institute India · ₹22,00,000, about USD 26,000 · Sole PI · 2013 to 2015",
    images: [],
    brief:
      "Two accessible mobile interaction studies commissioned by Samsung's India research institute and delivered as working prototypes with user studies: video viewing for hearing-impaired users, and one-handed interaction for using a large phone while standing, carrying, or holding a child.",
    videos: [
      { title: "Video viewing for hearing-impaired users", url: "https://youtube.com/watch?v=8r_aw1tXco0" },
      { title: "One-handed interaction", url: "https://youtube.com/watch?v=lOKliamGQzY" },
    ],
    site: null,
  },
  {
    key: "flexible-device-interaction",
    title: "Flexible device interaction",
    tags: ["Deformable interfaces", "Industry"],
    card: { type: "youtube", id: "HJqUIIvj-mA", file: "youtube-thumb-HJqUIIvj-mA.jpg" },
    cardBlurb:
      "What gestures should a deformable surface support, and how can bending, twisting and folding carry meaning without competing with touch?",
    cardMeta: "Nokia · 2015 to 2017",
    meta: "Nokia · €20,000 · Sole PI · 2015 to 2017",
    images: [],
    brief:
      "When the device itself bends, the interaction vocabulary of a rigid touchscreen stops being sufficient. This project investigated what gestures a deformable surface should support, and how bending, twisting and folding can carry meaning without competing with touch.",
    videos: [
      { title: "Project video 1", url: "https://youtube.com/watch?v=HJqUIIvj-mA" },
      { title: "Project video 2", url: "https://youtube.com/watch?v=aDSI5zG7fn4" },
      { title: "Project video 3", url: "https://youtube.com/watch?v=mJlA7DEfsgM" },
    ],
    site: null,
  },
];

export const CARD_ORDER = [
  "gyan-dhara",
  "evam",
  "disability-inclusive-virtual-shopping",
  "pragati",
  "swasthyaa",
  "chetna",
  "first-time-voter-training",
  "accessible-mobile-apps",
  "flexible-device-interaction",
];

export const HOME_FEATURED = [
  { key: "gyan-dhara", card: { type: "placeholder", file: "gd-students5.jpg" } },
  { key: "disability-inclusive-virtual-shopping", card: { type: "placeholder", file: "wm-test3.jpg" } },
  { key: "pragati", card: { type: "placeholder", file: "pragati-still.jpg" } },
];

export const TABLE_PROJECTS = [
  { project: "VR arthroscopy training and assessment", funder: "Healthium Medtech", value: "₹75,00,000", role: "Sole PI, 2024 to 2025" },
  { project: "WASH Experience and Knowledge Centre", funder: "Jal Jeevan Mission, Assam", value: "₹51,50,000", role: "Sole PI, consultancy" },
  { project: "Incentives to improve TB treatment adherence", funder: "NIHA, Singapore", value: "USD 120,000", role: "Co-PI, 2021 to 2023" },
  { project: "E-Budget Assam", funder: "Ministry of Finance, Govt. of Assam", value: "₹10,00,000", role: "Sole PI, 2018" },
  { project: "Microsoft Research Connector, HCI and UX internships", funder: "Microsoft Research", value: "₹6,00,000", role: "Sole PI" },
];

export const TABLE_FOOTNOTE =
  "Amounts are the sanctioned figures. Two projects are excluded from this list as infrastructure setup rather than research: the VR Zone at Guwahati Planetarium, and a product design engagement.";

export { ytThumb };
